import { render, staticRenderFns } from "./BrandTrends.vue?vue&type=template&id=38bda26a&lang=pug&"
import script from "./BrandTrends.vue?vue&type=script&lang=ts&"
export * from "./BrandTrends.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports